import { TextField as MyTextField } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import {
  Datagrid,
  DateField,
  ExportButton,
  Filter,
  FilterButton,
  List,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import XLSX from "xlsx";
import { parentActive, parentReadMany } from "../../provider/provider";

const ParentFilter = (props) => {
  const [value, setValue] = React.useState("");

  useEffect(() => {
    if (value && value.trim().length > 0) {
      props?.setValue(value.split(",").map((it) => it.trim()));
    } else {
      props?.setValue([]);
    }
  }, [value]);

  return (
    <Filter {...props}>
      {/* <TextInput label="Search by Id" source="id" alwaysOn /> */}
      <TextInput label="Search by Email" source="email" alwaysOn />
      <TextInput label="Search by mobile" source="mobile" alwaysOn />

      <MyTextField
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
        alwaysOn
        label="Parent Ids"
        multiline
        fullWidth
        sx={{ width: "400px" }}
      />
    </Filter>
  );
};

function formatIndianMobile(mobileNumber) {
  let cleaned = mobileNumber.replace(/\D/g, "");

  if (cleaned.startsWith("0")) {
    cleaned = cleaned.slice(1); // Remove the leading 0
  }

  // Check if the number is a valid Indian mobile number
  if (cleaned.length === 10) {
    // If it's a 10-digit number, add +91
    return "+91" + cleaned;
  } else if (cleaned.length === 12 && cleaned.startsWith("91")) {
    // If it's already a 12-digit number starting with 91, add +
    return "+" + cleaned;
  } else if (cleaned.length === 13 && cleaned.startsWith("+91")) {
    // If it already has the +91 prefix, return as is
    return cleaned;
  } else {
    return;
  }
}

export async function ParentExporter() {
  const users = await parentReadMany("", "", true);
  console.log(users);
  const parsedRows = users.data.map((it) => {
    return {
      Id: it?.id ?? "",
      Name: it?.name ?? "",
      "Mobile Number": formatIndianMobile(it?.mobile ?? ""),
      Email: it?.email ?? "",
      SignupDate: dayjs(it?.createdDate).format("DD-MM-YYYY hh:mm a"),
    };
  });
  const worksheet = XLSX.utils.json_to_sheet(parsedRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
  XLSX.writeFile(workbook, "UserExport.xlsx");
}

export async function ParentExporterActive() {
  const users = await parentActive();
  console.log(users);
  const parsedRows = users.data.map((it) => {
    return {
      Id: it?.id ?? "",
      Name: it?.name ?? "",
      "Mobile Number": formatIndianMobile(it?.mobile ?? ""),
      Email: it?.email ?? "",
      SignupDate: dayjs(it?.createdDate).format("DD-MM-YYYY hh:mm a"),
    };
  });
  const worksheet = XLSX.utils.json_to_sheet(parsedRows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Users");
  XLSX.writeFile(workbook, "UserExport.xlsx");
}

export const ParentList = (props) => {
  const [value, setValue] = React.useState([]);
  console.log("value", value);
  return (
    <List
      {...props}
      actions={
        <TopToolbar>
          <FilterButton
            filters={[<ParentFilter value={value} setValue={setValue} />]}
          />
          <ExportButton exporter={ParentExporter} />
          <ExportButton exporter={ParentExporterActive} label="Active Export" />
        </TopToolbar>
      }
      filters={<ParentFilter value={value} setValue={setValue} />}
      filter={value && value.length > 0 ? { id: value } : {}}
      // aside={<Aside />}
    >
      <Datagrid rowClick="show">
        <TextField source="id" />
        <TextField source="name" />

        <TextField source="email" />
        <TextField source="mobile" />
        <DateField
          source="createdDate"
          options={{ year: "numeric", month: "long", day: "numeric" }}
        />
      </Datagrid>
    </List>
  );
};
